// Default, clean certificate design (tokenised SVG). This is the starting
// point the admin can edit/redesign in the SVG editor and then "Save as
// template" for reuse. Tokens are filled from the selected student's data:
//   {{name}} {{certificate_id}} {{course}} {{start_date}} {{end_date}} {{issued_date}}
//
// Each dynamic value is its own <text> element so it can be dragged/edited
// independently. viewBox is 1000x700; PNG export upscales it for print.

export const CERT_VIEWBOX = { width: 1000, height: 700 };

export const DEFAULT_CERTIFICATE_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 700" font-family="Georgia, 'Times New Roman', serif">
  <rect x="0" y="0" width="1000" height="700" fill="#ffffff"/>
  <rect x="22" y="22" width="956" height="656" fill="none" stroke="#1a3c6e" stroke-width="6"/>
  <rect x="36" y="36" width="928" height="628" fill="none" stroke="#c9a227" stroke-width="2"/>
  <text x="500" y="132" text-anchor="middle" font-size="48" fill="#1a3c6e" font-weight="bold" letter-spacing="3">CERTIFICATE</text>
  <text x="500" y="172" text-anchor="middle" font-size="20" fill="#c9a227" letter-spacing="8">OF ACHIEVEMENT</text>
  <text x="500" y="238" text-anchor="middle" font-size="18" fill="#666">This certificate is proudly presented to</text>
  <text x="500" y="312" text-anchor="middle" font-size="50" fill="#111111" font-weight="bold">{{name}}</text>
  <line x1="290" y1="334" x2="710" y2="334" stroke="#c9a227" stroke-width="1.5"/>
  <text x="500" y="388" text-anchor="middle" font-size="18" fill="#666">for successfully completing</text>
  <text x="500" y="430" text-anchor="middle" font-size="30" fill="#1a3c6e" font-weight="bold">{{course}}</text>
  <text x="500" y="476" text-anchor="middle" font-size="16" fill="#666">from {{start_date}} to {{end_date}}</text>
  <text x="200" y="596" text-anchor="middle" font-size="16" fill="#111111">{{issued_date}}</text>
  <line x1="118" y1="612" x2="282" y2="612" stroke="#999999" stroke-width="1"/>
  <text x="200" y="636" text-anchor="middle" font-size="13" fill="#888">Issued Date</text>
  <line x1="718" y1="612" x2="882" y2="612" stroke="#999999" stroke-width="1"/>
  <text x="800" y="636" text-anchor="middle" font-size="13" fill="#888">Authorised Signatory</text>
  <text x="500" y="664" text-anchor="middle" font-size="13" fill="#aaaaaa">Certificate ID: {{certificate_id}}</text>
</svg>`;

export default DEFAULT_CERTIFICATE_SVG;
